import _ from 'lodash';
import angular from 'angular';
import template from './template.html';
import BaseComponent from '../../../../base/component';
import { Async, Inject } from '../../../../base/decorators';
import UtilsService from '../../../../../services/utilsService';

export class EmployerRepSignUpPassword extends BaseComponent {
    @Inject('$stateParams') $stateParams;
    @Inject('EmployerRepService') employerRepService;
    @Inject('EmployerService') employerService;
    @Inject('$localStorage') $localStorage;
    @Inject('AuthService') authService;
    @Inject('NotificationService') notificationService;
    @Inject('RouteService') routeService;
    @Inject('EnvSettings') envSettings;
    @Inject('$cookies') $cookies;
    linkedInIcon = {
        cssClass: 'linkedin-icon',
        src: 'assets/img/icons/build/svg-sprite.svg#linkedin',
    };

    async setupComponentData() {
        UtilsService.cookiesOverride(this.$cookies);
        const { employerRepId, invitationId } = this.$stateParams;
        this.$localStorage.employerRepReturnUrlParams = this.$localStorage.employerRepReturnUrlParams || {};
        this.$localStorage.employerRepReturnUrlParams.currentEmployerRepId = employerRepId;

        const { result: employerRepData } = (invitationId
            ? await this.employerRepService.getEmployerRepByInvitationId(invitationId)
            : await this.employerRepService.getEmployerRepDetails(employerRepId)
        ) || {};

        this.employerRepData = employerRepData;
        this.isRegistrationWithLinkedInAvailable = this.routeService.getSystemDefaults('isRegistrationWithLinkedInAvailable');
        this.tftMainLogoUrl = await this.routeService.getThemeSettingsAsync('tftMainLogoUrl') || '';
        this.auth0Account = employerRepData.auth0Account;
    }

    getFormHeaderTranslationId() {
        return this.auth0Account ? 'EMPLOYER_SIGN_UP_NEW' : 'EMPLOYER_SIGN_UP';
    }

    getFormDescriptionTranslationId() {
        return this.auth0Account ? 'INVITVATION_TITLE_SIGNUP_NEW' : 'INVITVATION_TITLE_SIGNUP';
    }

    @Async()
    async activateEmpRep(type, loginWithApp) {
        const { employerRepId, employerId, isSso, successUrl, invitationId } = this.$stateParams;
        if (!employerRepId) {
            this.$state.go('logout');
        }

        if (type === 'password') {
            if (_.get(this, 'password.length', 0) < 6 || _.get(this, 'repeat.length', 0) < 6) {
                this.errorMsg = 'PASSWORD_LENGTH_IS_AT_LEAST_6';

                return;
            }

            if (this.password !== this.repeat) {
                this.errorMsg = 'PASSWORD_DOES_NOT_MATCHED';

                return;
            }

            this.errorMsg = '';

            const addEmployerRepToSystemResult = await this.employerRepService.addEmployerRepToSystem(employerRepId, {
                email: this.employerRepData.email,
                password: this.password,
                type,
                invitationId,
            });

            if (addEmployerRepToSystemResult.message) {
                if (_.includes(['INVITATION_NOT_FOUND', 'NOT_VALID_INVITATION'], addEmployerRepToSystemResult.message)) {
                    this.errorMsg = 'NOT_VALID_INVITATION';
                } else {
                    this.errorMsg = 'PASSWORD_LENGTH_IS_AT_LEAST_6_UPPER_LOWER';
                }
                this.$scope.$apply();
                return;
            }

            let error = null;
            if (isSso) {
                this.authService.goToSsoLoginPage(
                    this.envSettings.WebAppUrl,
                    employerId, this.employerRepData.email,
                    this.employerRepData?.isOnlyFastRatingAllowed,
                    successUrl,
                );
            } else {
                if (successUrl) {
                    const expiresInSec = 86400; // 60 * 60 * 24
                    const authTokenExpiresOnDate = moment().add(expiresInSec, 's').toDate();
                    const isRemoteHost = !(window.location.hostname.indexOf('localhost') > -1);

                    UtilsService.cookiesOverride(this.$cookies);

                    this.$cookies.put('activationSuccessUrl', successUrl, {
                        domain: window.location.hostname.split('.').slice(-2).join('.'), // set only domain zone and domain 1 level
                        secure: isRemoteHost,
                        samesite: 'strict',
                        expires: authTokenExpiresOnDate,
                    });
                }
                ({ error } = await this.authService.login({
                    username: this.employerRepData.email,
                    password: this.password,
                }, `employerRep/${employerRepId}/sign-up/activate`));
            }

            if (error) {
                this.notificationService.error('EMPLOYER_REP_ALREADY_EXIST_WITH_THIS_EMAIL');
            }

            this.$state.go('employerRep.signUp.activate', { employerRepId });
        } else if (type === 'social') {
            this.authService.loginWith(loginWithApp, `employerRep/${employerRepId}/sign-up/activate-linkedin`);
        } else if (type === 'signup') {
            await this.employerRepService.addEmployerRepToSystem(employerRepId, {
                email: this.employerRepData.email,
                type,
            });

            this.$state.go('logout');
        }
    }

    checkIfEnterKeyWasPressed = function (event) {
        const keyCode = event.which || event.keyCode;
        if (keyCode === 13) {
            this.activateEmpRep('password');
        }
    };
}

export const EmployerRepSignUpPasswordConfiguration = {
    template,
    controller: EmployerRepSignUpPassword,
    controllerAs: 'employerRepSignUpPasswordCtrl',
};

angular
    .module('TALENYA-FE')
    .component('employerRepSignUpPassword', EmployerRepSignUpPasswordConfiguration);

